import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ModelService } from "../../model.service";
import { PaneChild } from "../pane/pane.component";

@Component({
    selector: "app-model-list",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./model-list.component.html",
    styleUrls: ["./model-list.component.css"],
    standalone: false
})
export class ModelListComponent extends PaneChild {
    private _modelService: ModelService;

    public get models() { return this._modelService.models; }

    public constructor(modelService: ModelService) {
        super();
        this._modelService = modelService;
        modelService.modelListShow.subscribe(() => this.show());
    }

    public modelSelected(key: string) {
        this._modelService.openModel(key);
        this.close();
    }
}
